/**
 * GENERATED FILE — Do not hand edit.
 *
 * Source of truth: `shared/source-mappings.json`
 *
 * This file exists because:
 * - Cloudflare Workers + browser extension runtime cannot `fs.readFile()` JSON.
 * - Browser modules cannot reliably import JSON without bundler support.
 *
 * Keep generation simple: this is just data exported as an immutable object.
 */
export const SOURCE_MAPPINGS = Object.freeze(
  /** @type {const} */ (
    {
      $schemaVersion: 1,
      sources: [
        {
          id: 'google-docs',
          hosts: ['docs.google.com'],
          pathRegexes: ['^/document/'],
          shareImage: {
            type: 'static',
            url: 'https://gist.is/static/google-docs-og.png'
          },
          favicon: {
            type: 'static',
            url: 'https://gist.is/static/google-docs-favicon.png'
          }
        },
        {
          id: 'google-slides',
          hosts: ['docs.google.com'],
          pathRegexes: ['^/presentation/'],
          shareImage: {
            type: 'static',
            url: 'https://gist.is/static/google-slides-og.png'
          },
          favicon: {
            type: 'static',
            url: 'https://gist.is/static/google-slides-favicon.png'
          }
        },
        {
          id: 'google-drive',
          hosts: ['drive.google.com'],
          pathRegexes: [
            '^/file/',
            '^/drive/folders/',
            '^/drive/u/\\d+/folders/',
            '^/drive/my-drive'
          ],
          shareImage: {
            type: 'static',
            url: 'https://gist.is/static/google-drive-og.png'
          },
          favicon: {
            type: 'static',
            url: 'https://gist.is/static/google-drive-favicon.png'
          }
        },
        {
          id: 'youtube',
          hosts: ['youtube.com', 'www.youtube.com', 'm.youtube.com', 'youtu.be'],
          shareImage: {
            type: 'template',
            template: 'https://i.ytimg.com/vi/{id}/hqdefault.jpg',
            fallbackUrl: 'https://gist.is/static/youtube-og.png',
            idExtractors: [
              { type: 'host_path', host: 'youtu.be', pathRegex: '^/([^/]+)$' },
              {
                type: 'path_query',
                hostRegex: '(^|\\.)youtube\\.com$',
                pathRegex: '^/watch$',
                queryParam: 'v'
              },
              { type: 'host_path', hostRegex: '(^|\\.)youtube\\.com$', pathRegex: '^/shorts/([^/]+)' },
              { type: 'host_path', hostRegex: '(^|\\.)youtube\\.com$', pathRegex: '^/embed/([^/]+)' }
            ]
          }
        },
        {
          id: 'arxiv',
          hosts: ['arxiv.org', 'www.arxiv.org'],
          urlNormalization: [{ type: 'path_replace', pathRegex: '^/pdf/(.+?)\\.pdf$', replace: '/pdf/$1' }],
          shareImage: {
            type: 'static',
            url: 'https://gist.is/static/arxiv-og.png'
          },
          favicon: {
            type: 'static',
            url: 'https://gist.is/static/arxiv-favicon.png'
          }
        }
      ]
    }
  )
);
